"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCartsStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
const i18n_1 = require("../../common/i18n");
const Cart_1 = __importDefault(require("./Cart"));
const CartProduct_1 = __importDefault(require("./CartProduct"));
const toastStore_1 = require("../toast/toastStore");
const createCartProductObject = (cartProduct) => {
    return new CartProduct_1.default(cartProduct.id, cartProduct.priceOptionCode, cartProduct.ean, cartProduct.manufacturerSku, cartProduct.name, cartProduct.info, cartProduct.quantity, cartProduct.weight, cartProduct.axType, cartProduct.axCategory, cartProduct.brandName, cartProduct.currencyCode, cartProduct.priceVatPercent, cartProduct.priceEpr, cartProduct.priceEco, cartProduct.priceNet, cartProduct.priceListNet, cartProduct.priceCustomNet, cartProduct.priceCustomNetId, cartProduct.treadCode, cartProduct.size, cartProduct.diameter, cartProduct.fuelEfficiency, cartProduct.wetGripClass, cartProduct.noiseMeasurementValue, cartProduct.loadIndex, cartProduct.speedIndex, cartProduct.stockInfo);
};
exports.useCartsStore = (0, pinia_1.defineStore)('cartsStore', {
    state: () => ({
        carts: [],
        activeCartId: null,
        activeCartModalVisible: false
    }),
    getters: {
        activeCart: (state) => {
            return state.activeCartId === null ? undefined : state.carts.find((cart) => cart.id === state.activeCartId);
        },
        getCartById: (state) => {
            return (cartId) => {
                return state.carts.find((cart) => cart.id === cartId);
            };
        }
    },
    actions: {
        async loadCarts(router) {
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'shop_carts' }).href);
                if (0 < response['hydra:member'].length) {
                    const carts = response['hydra:member'];
                    this.setCarts(carts);
                }
                else {
                    // if no cart, we need to create one
                    await this.createCart(router);
                }
            }
            catch (error) {
                console.error('Error loading carts:', error);
                throw error;
            }
        },
        async createCart(router) {
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'shop_carts' }).href, { method: 'POST', body: JSON.stringify({}) });
                if (response.id) {
                    const carts = [];
                    carts.push(response);
                    this.setCarts(carts);
                }
            }
            catch (error) {
                console.error('Error creating cart:', error);
                throw error;
            }
        },
        setCarts(carts) {
            this.carts = carts.map((cart) => {
                const cartProducts = cart.products.map((cartProduct) => {
                    return createCartProductObject(cartProduct);
                });
                return new Cart_1.default(cart.id, cart.createdUser, cart.createdDatetime, cart.updatedDatetime, cartProducts);
            });
            this.activeCartId = carts.length > 0 ? carts[0].id : null;
        },
        changeActiveCartId(cartId) {
            this.activeCartId = cartId;
        },
        refreshActiveCart(cart) {
            this.carts = this.carts.map((existingCart) => {
                if (existingCart.id === cart.id) {
                    const cartProducts = cart.products.map((cartProduct) => {
                        return createCartProductObject(cartProduct);
                    });
                    return new Cart_1.default(cart.id, cart.createdUser, cart.createdDatetime, cart.updatedDatetime, cartProducts);
                }
                return existingCart;
            });
        },
        showActiveCartModal(router) {
            this.activeCartModalVisible = true;
            const activeCart = this.activeCart;
            if (activeCart !== undefined && activeCart.getSize() > 0) {
                this.refreshStockInfos(router);
            }
        },
        closeActiveCartModal() {
            this.activeCartModalVisible = false;
        },
        async addProduct(router, quantity, productId) {
            if (0 === quantity) {
                (0, toastStore_1.useToastStore)().addToast({
                    message: i18n_1.Translator.trans('quantity_required', 'Quantity required!', 'carts'),
                    type: 'warning',
                    icon: 'marso-icon-shopping_cart',
                    timer: 5
                });
                return;
            }
            try {
                const response = await (0, fetch_1.default)(router.resolve({
                    name: 'shop_carts_add_product',
                    params: { id: this.activeCartId }
                }).href, {
                    method: 'POST',
                    body: JSON.stringify({ productId: productId, quantity: quantity })
                });
                this.refreshActiveCart(response);
                (0, toastStore_1.useToastStore)().addToast({
                    message: i18n_1.Translator.trans('product_added', 'Product added!', 'carts'),
                    type: 'info',
                    icon: 'marso-icon-shopping_cart',
                    timer: 5
                });
            }
            catch (error) {
                console.error('Error adding product to cart:', error);
                throw error;
            }
        },
        async updateProductQuantity(router, productId, quantity) {
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'shop_carts_update_product_quantity', params: { id: this.activeCartId } }).href, { method: 'PUT', body: JSON.stringify({ productId: productId, quantity: quantity }) });
                this.refreshActiveCart(response);
                (0, toastStore_1.useToastStore)().addToast({
                    message: i18n_1.Translator.trans('product_updated', 'Product updated!', 'carts'),
                    type: 'info',
                    icon: 'marso-icon-shopping_cart',
                    timer: 5
                });
            }
            catch (error) {
                console.error('Error updating product quantity:', error);
                throw error;
            }
        },
        async refreshStockInfos(router) {
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'shop_carts_refresh_stock_infos', params: { id: this.activeCartId } }).href, { method: 'PUT', body: JSON.stringify({}) });
                this.refreshActiveCart(response);
                (0, toastStore_1.useToastStore)().addToast({
                    message: i18n_1.Translator.trans('stock_info_refreshed', 'Stock info refreshed!', 'carts'),
                    type: 'info',
                    icon: 'marso-icon-shopping_cart',
                    timer: 5
                });
            }
            catch (error) {
                console.error('Error refreshing stock infos:', error);
                throw error;
            }
        },
        async removeProduct(router, productId) {
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'shop_carts_remove_product', params: { id: this.activeCartId } }).href, { method: 'DELETE', body: JSON.stringify({ productId: productId }) });
                this.refreshActiveCart(response);
                (0, toastStore_1.useToastStore)().addToast({
                    message: i18n_1.Translator.trans('product_removed', 'Product removed!', 'carts'),
                    type: 'info',
                    icon: 'marso-icon-shopping_cart',
                    timer: 5
                });
            }
            catch (error) {
                console.error('Error removing product from cart:', error);
                throw error;
            }
        },
        async emptyCart(router) {
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'shop_carts_empty', params: { id: this.activeCartId } }).href, { method: 'DELETE' });
                this.refreshActiveCart(response);
                (0, toastStore_1.useToastStore)().addToast({
                    message: i18n_1.Translator.trans('cart_emptied', 'Cart emptied!', 'carts'),
                    type: 'info',
                    icon: 'marso-icon-shopping_cart',
                    timer: 5
                });
            }
            catch (error) {
                console.error('Error emptying cart:', error);
                throw error;
            }
        }
    }
});
